import * as tagService from '@/service/tag'
import type { TagDetail } from '@/types/api'

export const useTagStore = defineStore('tag', () => {
  const nuxtApp = useNuxtApp()
  const { $axios } = nuxtApp

  const tag = ref<TagDetail>({})

  async function fetchTag(tagId: number | string) {
    const { data } = await tagService.getTagDetail($axios, tagId)

    tag.value = data ?? ({} as TagDetail)

    return data
  }

  function resetTag() {
    tag.value = {} as TagDetail
  }

  return {
    tag,
    fetchTag,
    resetTag,
  }
})
